import React, { useState } from 'react'

import { MdSearch, MdClose } from 'react-icons/md'
import { useTheme } from 'styled-components'

import { useSearch } from '@contexts/search'

import { Button, Container, InputField } from './styles'

export function InputSearch() {
  const { searchTerm, setSearchTerm } = useSearch()
  const [isFocused, setIsFocused] = useState(false)
  const theme = useTheme()

  function handleSearchValue(event: React.ChangeEvent<HTMLInputElement>) {
    setSearchTerm(event.target.value.toLocaleLowerCase())
  }

  function handleClearInput() {
    setSearchTerm('')
  }

  return (
    <Container>
      <MdSearch
        size={24}
        color={theme.colors.text}
        style={{ paddingLeft: 10, paddingRight: 5 }}
      />
      <InputField
        onChange={handleSearchValue}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        value={searchTerm}
        type="search"
        placeholder="Search"
      />
      {isFocused && searchTerm && (
        <Button onClick={handleClearInput}>
          <MdClose size={24} color={theme.colors.text} />
        </Button>
      )}
    </Container>
  )
}
